var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled, { css, ThemeProvider } from "styled-components";
import { get } from 'lodash-es';
import { doconTheme } from "../../../theme/default";
import { Body1 } from "../../../doconV2";
import { BaseBox, FlexBox } from "../../shared/Element";
import { ChevronIcon } from '../../shared/icons';
var Title = styled(Body1)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  color: ", ";\n  transition: all .3s linear;\n  cursor: pointer;\n"], ["\n  flex: 1;\n  color: ", ";\n  transition: all .3s linear;\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.v2.colors.heading;
});
var Header = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  gap:10px;\n\n  ", " {\n    cursor: pointer;\n  }\n"], ["\n  gap:10px;\n\n  ", " {\n    cursor: pointer;\n  }\n"])), ChevronIcon);
var Content = styled(BaseBox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  max-height: 0;\n  transition: all ", " ease-in-out;\n  overflow: hidden;\n\n  ", "\n"], ["\n  color: ", ";\n  max-height: 0;\n  transition: all ", " ease-in-out;\n  overflow: hidden;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.v2.colors.heading;
}, function (_a) {
    var $maxHeight = _a.$maxHeight, $transitionFactor = _a.$transitionFactor;
    return $maxHeight ? $maxHeight / $transitionFactor + "s" : '1s';
}, function (props) { return props.$isExpand && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-height: ", ";\n  "], ["\n    max-height: ", ";\n  "])), function (_a) {
    var $maxHeight = _a.$maxHeight;
    return $maxHeight ? $maxHeight + "px" : 'auto';
}); });
var Root = styled(BaseBox)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: relative;\n  border-bottom: solid 1px ", ";\n\n  ", " {\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  position: relative;\n  border-bottom: solid 1px ", ";\n\n  ", " {\n    color: ", ";\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.v2.colors.borderColor;
}, ChevronIcon, function (_a) {
    var theme = _a.theme;
    return theme.v2.colors.primary[0];
}, function (props) { return props.$isExpand && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", " { font-weight: bold; }\n  "], ["\n    ", " { font-weight: bold; }\n  "])), Title); });
var DoconCollapse = function (_a) {
    var hideIcon = _a.hideIcon, titleClassName = _a.titleClassName, isActive = _a.isActive, title = _a.title, customHeader = _a.customHeader, id = _a.id, _b = _a.transitionFactor, transitionFactor = _b === void 0 ? 200 : _b, minHeight = _a.minHeight, _c = _a.iconSize, iconSize = _c === void 0 ? 16 : _c, _d = _a.p, p = _d === void 0 ? '9px 27px' : _d, children = _a.children, onHeaderClick = _a.onHeaderClick, props = __rest(_a, ["hideIcon", "titleClassName", "isActive", "title", "customHeader", "id", "transitionFactor", "minHeight", "iconSize", "p", "children", "onHeaderClick"]);
    var _e = __read(useState(isActive || false), 2), isExpand = _e[0], setIsExpand = _e[1];
    var _f = __read(useState(minHeight || 500), 2), maxHeight = _f[0], setMaxHeight = _f[1];
    var contentRef = useRef(null);
    useEffect(function () {
        var scrollHeight = get(contentRef, 'current.scrollHeight', 500);
        if (!minHeight && scrollHeight !== maxHeight) {
            setMaxHeight(scrollHeight);
        }
    }, [maxHeight, children]);
    useEffect(function () {
        if (isActive !== isExpand) {
            setIsExpand(isActive);
        }
    }, [isActive]);
    function handleClick() {
        setIsExpand(function (state) { return !state; });
        if (onHeaderClick) {
            onHeaderClick({ id: id, title: title, isExpand: isExpand });
        }
    }
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Root, __assign({ "$isExpand": isExpand, p: p }, props),
            React.createElement(Header, { onClick: handleClick },
                customHeader || React.createElement(Title, { title: title, className: titleClassName }),
                hideIcon ? null : React.createElement(ChevronIcon, { width: iconSize, type: isExpand ? 'down' : 'right' })),
            React.createElement(Content, { "$isExpand": isExpand, "$maxHeight": maxHeight, "$transitionFactor": transitionFactor, ref: contentRef }, children))));
};
export { Header, Content, };
export default styled(DoconCollapse)(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
